import createTheme from '@mui/material/styles/createTheme';

// often used breakpoints in MUI default theme
// sm, small: 600px
// md, medium: 900px
// lg, large: 1200px

export const generateTheme = (container: Element | null) => {
  const rootEl = (container as Element) || document.documentElement;
  const primaryColor =
    getComputedStyle(rootEl).getPropertyValue('--primary-color').trim() || '#FFAB00';
  const secondaryColor =
    getComputedStyle(rootEl).getPropertyValue('--secondary-color').trim() || '#f1c46b';
  const tailwindOverride = {
    defaultProps: {
      container,
      fontSize: {
        sm: '0.5rem',
        base: '1rem',
        xl: '1.25rem',
        '2xl': '1.563rem',
        '3xl': '1.953rem',
        '4xl': '2.441rem',
        '5xl': '3.052rem',
      },
      // popup components 定位在页面最下方，并且宽度为 100%
    },
  };
  const dialogOverride = {
    styleOverrides: {
      paper: {
        width: '100%',
        maxWidth: '100%',
        alignItems: 'flex-end',
        borderLeftRadius: '0.5rem',
        borderRightRadius: '0.5rem',
        margin: 0,
        bottom: 0,
        position: 'absolute' as 'absolute',
      },
    },
  };
  const dialogTitleOverride = {
    styleOverrides: {
      root: {
        color: '#111928',
        alignContent: 'center',
        width: '100%',
        height: '3rem',
        fontSize: '0.875rem',
        textAlign: 'center' as 'center',
      },
    },
  };
  return createTheme({
    palette: {
      primary: {
        main: primaryColor,
        contrastText: '#ffffff',
      },
      secondary: {
        main: secondaryColor,
        contrastText: '#111928',
      },
      error: {
        main: '#F05252',
        contrastText: '#ffffff',
      },
    },

    components: {
      // overrides for MUI popup components
      MuiPopover: tailwindOverride,
      MuiPopper: tailwindOverride,
      MuiDialog: dialogOverride,
      MuiDialogTitle: dialogTitleOverride,
      MuiModal: tailwindOverride,
      MuiButton: {
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              backgroundColor: 'var(--button-disabled-bgcolor)',
              color: 'var(--font-color-white)',
            },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: '#f3f4f6',
            color: '#111928',
            boxShadow: 'none',
            // borderBottom: '1px solid #E5E5E5',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            '&.MuiButtonBase-root': {
              color: '#111928',
              fontWeight: 400,
            },
            '&.Mui-selected': {
              color: '#111928',
              fontWeight: 600,
            },
            '&:focus': {
              backgroundColor: 'transparent',
              // 其他样式
            },
          },
        },
      },
    },
    typography: {
      button: {
        textTransform: 'none',
      },
    },
  });
};
